import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Download, FileX2 } from "lucide-react";
import { api, API } from "@/lib/api";

export default function ResourceDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/resources/${id}`)
      .then((r) => setItem(r.data.item))
      .catch(() => setErr("Kaynak bulunamadı."))
      .finally(() => setLoading(false));
  }, [id]);

  const download = async () => {
    const token = localStorage.getItem("life101_user_token");
    const res = await fetch(`${API}/resources/${id}/file`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = item.pdf_filename || "kaynak.pdf";
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) return <div className="text-center py-24 text-neutral-500">Yükleniyor...</div>;
  if (err || !item) return (
    <div className="text-center py-24" data-testid="resource-not-found">
      <p className="text-neutral-400">{err || "Kaynak bulunamadı."}</p>
      <Link to="/kaynaklar" className="btn-secondary inline-flex items-center gap-2 mt-6"><ArrowLeft size={14} /> Kaynaklara Dön</Link>
    </div>
  );

  const hasFile = Boolean(item.pdf_path);

  return (
    <div className="max-w-3xl mx-auto" data-testid="resource-detail-page">
      <Link to="/kaynaklar" className="text-sm text-neutral-400 hover:text-white inline-flex items-center gap-2 mb-6">
        <ArrowLeft size={14} /> Tüm Kaynaklar
      </Link>

      <div className="text-xs text-neutral-500 uppercase tracking-[0.12em]">{item.category_label}</div>
      <h1 className="mt-3 text-4xl md:text-5xl font-semibold tracking-tight h-gradient">{item.title}</h1>
      <p className="mt-5 text-neutral-300 leading-relaxed max-w-2xl">{item.description}</p>

      <div className="glass mt-10 p-8" data-testid="resource-file-block">
        {hasFile ? (
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
            <div>
              <div className="text-xs uppercase tracking-[0.15em] text-neutral-500">Kaynak Dosyası</div>
              <div className="mt-2 text-lg text-white">{item.pdf_filename}</div>
              {item.pdf_size && (
                <div className="text-xs text-neutral-500 mt-1">{(item.pdf_size / 1024).toFixed(0)} KB</div>
              )}
            </div>
            <button onClick={download} className="btn-primary inline-flex items-center gap-2" data-testid="resource-download-btn">
              <Download size={16} /> İndir
            </button>
          </div>
        ) : (
          <div className="text-center py-8" data-testid="resource-empty">
            <FileX2 size={36} className="mx-auto text-neutral-600" />
            <p className="mt-4 text-neutral-400">Şu an bir kaynak bulunmamaktadır.</p>
            <p className="text-xs text-neutral-600 mt-2">İçerik en kısa sürede eklenecek.</p>
          </div>
        )}
      </div>

      <div className="mt-10">
        <button onClick={() => nav("/kaynaklar")} className="btn-secondary">Diğer Kaynaklara Bak</button>
      </div>
    </div>
  );
}
